import { axiosInstance as axios } from "./api";

import { APIGW_ROOT } from './api';

const proxyurl = ''

const APIGW_ROOT_TOKENS= `${proxyurl}${APIGW_ROOT}accounts/`;

export default class UsertokenModel {

    constructor() {
    }

    /* 
    [
      {
        "createdAt": "2020-10-12 15:00:00",
        "createdBy": "465b6018-3ab5-45b3-b0c5-9d04ba24a0be",
        "email": "test@test.ts",
        "id": "465b6018-3ab5-45b3-b0c5-9d04ba24a0be",
        "kind": "INDIVIDUAL"
      }
    ]
    */

    fetchAccounts(token) {
      return new Promise(async (ok, reject) => {     
        try {
          const res = await axios.get(
              `${APIGW_ROOT_TOKENS}`, 
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
              );
          
          if (res.status !== 200) {
            reject(res.statusText)
          }
          ok(res)
        } catch (e) {
          ErrorHandler(reject, e)
        }
      })
    }

    /* 
    tokens = [
      {
        "created": "2020-10-12 15:00:00",
        "expired": "2020-10-12 15:00:00",
        "name": "465b6018",
        "numConnections": 12,
        "token": "465b6018",
        "userID": "465b6018-3ab5-45b3-b0c5-9d04ba24a0be"
      }
    ]
    
    */

    fetchAllTokensForUser(token, accountID) {
        return new Promise(async (ok, reject) => {     
            try {
              const res = await axios.get(
                  `${APIGW_ROOT_TOKENS}${accountID}/tokens`, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
                  );
              
              if (res.status !== 200) {
                reject(res.statusText)
              }
              ok(res)
            } catch (e) {
              ErrorHandler(reject, e)
            }
          })
    }


    /* 
    payload = {
        "expired": 1608460386,
        "name": "token name"
    }
    */

    addNewToken(token, accountID, payload) {
        return new Promise((async (ok, reject) => {    
          try {
            const res = await axios.post(
              `${APIGW_ROOT_TOKENS}${accountID}/tokens`, 
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
              ok(res)
            }
          } catch (e) {
            ErrorHandler(reject, e)
          }
        }))
    }

    deleteToken(token, accountID, tokenToDelete) {
        return new Promise((async (ok, reject) => {    
          try {
            const res = await axios.delete(
                `${APIGW_ROOT_TOKENS}${accountID}/tokens/${tokenToDelete}`, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
              ok(res)
            }
          } catch (e) {
            ErrorHandler(reject, e)
          }
        }))
    }

  }
  
  
  
  // Error handler 
  const ErrorHandler = (r, e) => {  
    if (e.response && typeof(e.response.data) === "object" && "error" in e.response.data) {
      console.log(Error(e.response.data.error))
      r(Error(e.response.data.error))
    }
  
    if (e.response && typeof(e.response.data) === "string") {
      console.log(Error(e.response.data))
      r(Error(e.response.data))
    }

    r(e)
  }
  